var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"grey lighten-2","depressed":"","rounded":"","block":""},on:{"click":function($event){return _vm.backStep()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v("Voltar ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }